<template>
  <nav class="nav">
    <router-link to="/" data-title="Zawody" tag="button" exact>
      <font-awesome-icon icon="home" />
    </router-link>
    <router-link to="/participants" data-title="Zawodnicy" tag="button">
      <font-awesome-icon icon="users" />
    </router-link>
    <router-link to="/qualifications" data-title="Kwalifikacje" tag="button">
      <font-awesome-icon icon="clipboard-list" />
    </router-link>
    <router-link to="/finals" data-title="Pojedynki" tag="button">
      <font-awesome-icon icon="fire" />
    </router-link>
    <!-- <router-link to="/winners" data-title="Zwycięzcy">
      <font-awesome-icon icon="award"/>
    </router-link> -->
  </nav>
</template>

<script>
export default {
  name: 'Nav',
  computed: {
    lockedTabs() {
      return this.$store.state.cache.live.lockedTabs
    },
  },
  methods: {
    isDisabled(nr) {
      return this.lockedTabs.indexOf(nr) > -1
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

.nav {
  height: calc(100vh - 64px);
  width: 64px;
  box-sizing: border-box;
  background-color: #fff;
  padding-top: 100px;
  border-right: solid 1px #edeff6;
  background-color: #fff;

  @media #{$media-sm} {
    width: 100%;
    height: 54px;
    position: fixed;
    bottom: 0;
    padding-top: 0;
    display: flex;
    justify-content: space-around;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    z-index: 1000;

    box-shadow: 0px 0px 1px 1px #edeff6;
  }

  button {
    all: unset;
    color: #bbb;
    background-color: transparent;
    border: none;
    width: 100%;
    height: 62px;
    border-right: solid 2px transparent;
    transition: 0.3s;
    font-size: 1.1em;
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    @media #{$media-sm} {
      font-size: 1.1em;
      width: 15%;
      height: auto;
      border-right: none;
      border-bottom: solid 2px transparent;
      margin: 8px;
    }

    &::after {
      position: absolute;
      content: attr(data-title);
      background-color: var(--dark);
      max-width: 100px;
      color: #fefefe;
      padding: 3px 8px;
      font-size: 0.8rem;
      border-radius: 10px;
      top: 50%;
      transform: translateY(-50%);
      left: calc(100% + 8px);
      visibility: hidden;
      opacity: 0;
      transition: 0.3s;
      z-index: 101;

      @media (prefers-color-scheme: dark) {
        color: #fff;
      }

      @media #{$media-sm} {
        display: none;
      }

      @media (max-width: 500px) {
        display: none;
      }
    }

    &:hover {
      border-right-color: var(--primary);
      color: var(--primary);

      &::after {
        visibility: visible;
        opacity: 1;
      }
    }

    &.router-link-active {
      color: var(--orange);
      border-right-color: var(--orange);

      @media #{$media-sm} {
        border-bottom-color: var(--orange);
        transform: translateY(-5px);
      }
    }

    &.link-locked {
      color: #ddd;
      cursor: not-allowed;

      &:hover {
        border-right-color: transparent;
        color: #ddd;
      }
    }
  }
}
</style>
